exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mt-5[data-v-6af844de]{margin-top:50px}", ""]);

// exports
